<template>
    <div class="mt4 content">
        <div class="columns pt-6">
            <div class="column is-list">
                <p class="has-text-white" v-if="conferences === null"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading conferences...</p>
                <div v-else>
                    <empty-state v-if="conferences.length === 0" icon="fa-info-circle" title="No conferences are open right now." text="Check back soon, or use an access code from your organizer under Conference Records."/>

                    <section class="pb-4" v-if="featuredConferences.length > 0">
                        <section-header title="Upcoming & Recent Conferences" icon="fa-calendar-alt" :count="featuredConferences.length"/>
                        <conference :conference="c" v-for="c in featuredConferences" :key="'featured-' + c.id" class="mb-5"/>
                    </section>

                    <section class="pb-6" v-if="conferences.length">
                        <section-header class="mt-6" title="All Conferences" icon="fa-presentation" :count="conferences.length"/>

                        <!-- Same year bar as the record archives (Completed Enrollments etc.) -->
                        <year-tabs :years="yearTabs" :value="activeYear" @input="year = $event" class="mt-4"/>
                        <empty-state v-if="getByYear(activeYear).length === 0" icon="fa-info-circle" :text="'No conferences in ' + activeYear + '.'"/>
                        <conference :conference="c" v-for="c in getByYear(activeYear)" :key="'year-' + activeYear + '-' + c.id" class="mb-5"/>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Conference from "../../components/Conference";
    import SectionHeader from "../../components/framework/SectionHeader";
    import EmptyState from "../../components/framework/EmptyState";
    import YearTabs from "../../components/framework/YearTabs";
    import {defaultYearKey} from "../../utils/yearBuckets";
    import {client as http} from "../../http_client";
    import moment from "moment";

    export default {
        components: {Conference, SectionHeader, EmptyState, YearTabs},
        data: function() {
            return {
                conferences: null,
                years: Array.from({length: 6}, (v, k) => new Date().getFullYear() - k),
                year: null
            };
        },
        computed: {
            yearTabs() {
                return this.years.map(y => ({key: y, label: String(y), count: this.getByYear(y).length}));
            },
            activeYear() {
                return this.years.includes(this.year) ? this.year : defaultYearKey(this.years);
            },
            // Starting within 30 days, started within the last 14, or pinned
            featuredConferences: function() {
                if (!this.conferences) return [];
                return this.conferences.filter(c => {
                    let start = moment(c.start_at);
                    return start.isBetween(moment(), moment().clone().add(30, 'days')) ||
                        start.isBetween(moment().clone().subtract(14, 'days'), moment()) || c.is_highlighted;
                });
            }
        },
        methods: {
            getByYear(year) {
                if (!this.conferences) return [];
                return this.conferences.filter(c => new Date(c.start_at).getFullYear() === year);
            }
        },
        mounted() {
            http.get('app/conferences/', {force: true}).then(response => {
                this.conferences = response.data;
            }).catch(err => {
                console.error('Conference list failed', err);
                this.conferences = [];
            });
        }
    };
</script>
